<div class="template-page">
  <div class="header">
    <div class="title">
      <span *ngIf="dialogData" class="icon"><i class="mdi mdi-text-box"></i></span>
      {{ title }}
      <span *ngIf="!dialogData">
        <button mat-raised-button class="refresh-btn" (click)="refreshTemplates()">REFRESH</button>
      </span>
      <span *ngIf="dialogData" class="close"
        ><i class="mdi mdi-close close-icon" mat-dialog-close></i
      ></span>
    </div>
  </div>
  <progress-spinner *ngIf="isLoading"></progress-spinner>

  <mat-tab-group class="users-tab-group" (selectedTabChange)="onSelectTab($event)">
    <mat-tab label="My templates">
      <div class="table-content" *ngIf="selectedIndex === 0">
        <viavi-template-data
          [dataSource]="templateDataSource"
          [columnHeaders]="myTemplateColumns"
          [tableId]="'my_template_tab'"
          (rowActionEmit)="onRowActionClick($event)"
          (removeTemplatesEmit)="removeTemplates($event.selectedItems, $event.actionName)"
          [isCheckBoxEnabled]="isCheckBoxEnabled"
          [resetCheckbox]="resetCheckbox"
        >
        </viavi-template-data>
      </div>
    </mat-tab>
    <mat-tab label="Shared templates">
      <div class="table-content" *ngIf="selectedIndex === 1">
        <viavi-template-data
          [dataSource]="templateDataSource"
          [columnHeaders]="sharedTemplateColumns"
          [tableId]="'shared_template_tab'"
          (rowActionEmit)="onRowActionClick($event)"
          (removeTemplatesEmit)="removeTemplates($event.selectedItems, $event.actionName)"
          [resetCheckbox]="resetCheckbox"
        >
        </viavi-template-data>
      </div>
    </mat-tab>
    <mat-tab label="All templates" *ngIf="hasManagePermissionRole && !dialogData">
      <div class="table-content" *ngIf="selectedIndex === 2">
        <viavi-template-data
          [dataSource]="templateDataSource"
          [columnHeaders]="sharedTemplateColumns"
          [tableId]="'all_template_tab'"
          (rowActionEmit)="onRowActionClick($event)"
          (removeTemplatesEmit)="removeTemplates($event.selectedItems, $event.actionName)"
          [resetCheckbox]="resetCheckbox"
        >
        </viavi-template-data>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
